import React from "react";
import {
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Typography,
  ListItem,
  Collapse
} from "@material-tailwind/react";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

const servicesMenuItems = [
  {
    title: "Product Scope",
    description: "A structured 15 day process to align your product vision with your business goals.",
    link:"/product-scope",
  },
  {
    title: "UX/UI Design",
    description: "Design an engaging product that is easy-to-use, attractive and functional.",
    link:"/ui-ux",
  },
  {
    title: "MVP Builder",
    description: "Go to the market quickly with a high-quality Minimum Viable Product.",
    link:"/mvp-builder",
  },
  {
    title: "Dedicated Teams",
    description: "Build your product with a dedicated team of developers.",
    link:"/dedicated-teams",
  },
  {
    title: "Custom Software Development",
    description: "Lean frameworks applied to your vision to create an innovative custom software solution.",
    link:"/custom-software-development",
  },
  {
    title: "AI Development & Enablement",
    description: "We leverage ML and Generative AI strategically to ensure your business is future-ready.",
    link:"/service-ai",
  },
];

function NavListMenu() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);

  const renderItems = servicesMenuItems.map(({ link , title, description }, key) => (
    <a href={link} key={key}>
      <MenuItem className="flex items-center gap-3 rounded-lg">
        <div>
          <Typography
            variant="h6"
            color="blue-gray"
            className="flex items-center text-sm font-bold"
          >
            {title}
          </Typography>
          <Typography
            variant="paragraph"
            className="text-xs !font-medium text-blue-gray-500"
          >
            {description}
          </Typography>
        </div>
      </MenuItem>
    </a>
  ));

  return (
    <React.Fragment>
      <Menu
        open={isMenuOpen}
        handler={setIsMenuOpen}
        offset={{ mainAxis: 20 }}
        placement="bottom"
        allowHover={true}
      >
        <MenuHandler>
          <Typography as="div" variant="small" className="font-medium">
            <ListItem
              className="flex items-center gap-2 py-2 pr-4 font-medium font-poppins hover:font-poppins hover:text-[#96226E]"
              selected={isMenuOpen || isMobileMenuOpen}
              onClick={() => setIsMobileMenuOpen((cur) => !cur)}
            >
              Services
              <ChevronDownIcon
                strokeWidth={2.5}
                className={`hidden h-3 w-3 transition-transform lg:block ${
                  isMenuOpen ? "rotate-180" : ""
                }`}
              />
              <ChevronDownIcon
                strokeWidth={2.5}
                className={`block h-3 w-3 transition-transform lg:hidden ${
                  isMobileMenuOpen ? "rotate-180" : ""
                }`}
              />
            </ListItem>
          </Typography>
        </MenuHandler>
        <MenuList className="hidden max-w-screen-xl rounded-xl lg:block">
          <ul className="grid grid-cols-2 gap-y-2 outline-none outline-0">
            {renderItems}
          </ul>
        </MenuList>
      </Menu>
      <div className="block lg:hidden">
        <Collapse open={isMobileMenuOpen}>{renderItems}</Collapse>
      </div>
    </React.Fragment>
  );
}

export default NavListMenu;